import {Panel, PanelBody, PanelRow} from "@wordpress/components";

import {__} from '@wordpress/i18n';
import CheckboxOption from "../../options/CheckboxOption";
import InputOption from "../../options/InputOption";

export default function ColumnsPanel({attributes, setAttributes}) {
    return (
        <Panel>
            <PanelBody title={__('Columns', 'tier-pricing-table')} initialOpen={true}>

                <PanelRow>
                    <InputOption attributes={attributes}
                                 setAttributes={setAttributes}
                                 attributeName="quantityColumnTitle"
                                 label={__("Quantity column title", 'tier-pricing-table')}

                    />
                </PanelRow>
                {attributes.showDiscountColumn &&
                    <PanelRow>
                        <InputOption attributes={attributes}
                                     setAttributes={setAttributes}
                                     attributeName="discountColumnTitle"
                                     label={__("Discount column title", 'tier-pricing-table')}

                        />
                    </PanelRow>
                }
                <PanelRow>
                    <InputOption attributes={attributes}
                                 setAttributes={setAttributes}
                                 attributeName="priceColumnTitle"
                                 label={__("Price column title", 'tier-pricing-table')}

                    />
                </PanelRow>

                <PanelRow>
                    <CheckboxOption attributes={attributes}
                                    setAttributes={setAttributes}
                                    help={attributes.showDiscountColumn ?
                                        __("Discount column is showing.", 'tier-pricing-table') :
                                        __("Discount column is not showing.", 'tier-pricing-table')}
                                    label={__("Show percentage discount", 'tier-pricing-table')}
                                    attributeName="showDiscountColumn"/>
                </PanelRow>
            </PanelBody>
        </Panel>
    );
}
